module.exports = __webpack_public_path__ + "img/save.33928ed0.svg";